/*
 *  Define '$' handler (as wp only uses the 'jQuery' handler).
 * '$' must be imported into the files where you wish to use it ( import { $ } from './jquery-definition.js'; ).
 */

export const $ = jQuery;

window.$ = $;
